import { render, staticRenderFns } from "./sidebarWithdraw.vue?vue&type=template&id=1152e2b6&"
import script from "./sidebarWithdraw.vue?vue&type=script&lang=js&"
export * from "./sidebarWithdraw.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports